// utils/apiUtils.js
export const getApiUrl = (path) => {
  let baseUrl;
  const env = process.env.REACT_APP_ENV;
  
  if (env === 'development') {
    baseUrl = 'http://localhost:5000';
  } else if (env === 'staging') {
    baseUrl = 'https://staging.pehchaan.me';
  } else {
    baseUrl = 'https://pehchaan.me';
  }
    
  console.log("Path:",`${baseUrl}${path}`);
  return `${baseUrl}${path}`;
};

export const getAgentApiUrl = (path) => {
  // Get agent API base URL from environment variable
  // Default to localhost for development if not set
  let baseUrl;
  const env = process.env.REACT_APP_ENV;
  if (env === 'development') {
    baseUrl = 'http://localhost:8000';
  } else if (env === 'staging') {
    baseUrl = 'https://staging.agents.pehchaan.me';
  } else {
    baseUrl = 'https://agents.pehchaan.me';
  }
  console.log("Agent API Path:", `${baseUrl}${path}`);
  return `${baseUrl}${path}`;
};

export const fetchWithAuth = async (url, options = {}) => {
  const isFormData = options.body instanceof FormData;
  const defaultHeaders = isFormData
    ? { ...(options.headers || {}) } // Let browser set multipart boundaries
    : { 'Content-Type': 'application/json', ...(options.headers || {}) };

  return fetch(url, {
    credentials: 'include', // send cookies
    ...options,
    headers: defaultHeaders,
  });
};

// Fetch current token session (cookie based). Returns session JSON or null if unauthorized/expired.
export const fetchTokenSession = async () => {
  const url = getApiUrl('/auth/token-session');
  let response;
  try {
  // No need to specify method: 'GET' explicitly; fetch defaults to GET
  response = await fetchWithAuth(url);
  } catch (networkErr) {
    console.error('Network error while fetching token session', networkErr);
    throw networkErr; // propagate network issues
  }

  if (response.status === 401 || response.status === 403) {
    return null; // session missing or forbidden
  }

  if (!response.ok) {
    const text = await response.text().catch(() => '');
    throw new Error(`Failed to fetch token session: ${response.status} ${text}`);
  }

  try {
    const data = await response.json();
    return data;
  } catch (parseErr) {
    console.error('Failed to parse token session JSON', parseErr);
    throw parseErr;
  }
};